import { render, staticRenderFns } from "./documentosObrigatorios.vue?vue&type=template&id=6008f958&scoped=true"
import script from "./documentosObrigatorios.vue?vue&type=script&lang=js"
export * from "./documentosObrigatorios.vue?vue&type=script&lang=js"
import style0 from "./documentosObrigatorios.vue?vue&type=style&index=0&id=6008f958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6008f958",
  null
  
)

export default component.exports